module.exports = __webpack_public_path__ + "static/media/日历1@2x.6cb54b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历1@2x.png
// module id = 1374
// module chunks = 0